import { useQuery } from '@tanstack/react-query'
import { httpGetFullRejection } from '@/features/host-review/http/host-review.http'
import { QUERY_KEYS } from '@/query-client'

/**
 * One full rejection with the set the host saw. Null when the feature is off,
 * the review does not exist, or it is not a full rejection.
 */
export const useGetFullRejection = (reviewId?: string) =>
	useQuery({
		queryKey: [QUERY_KEYS.HOST_REVIEW_FULL_REJECTION, reviewId],
		queryFn: () => httpGetFullRejection(String(reviewId)),
		enabled: Boolean(reviewId),
		retry: false
	})
